// import required libraries
import $ from "jquery";

// import components that run on every page
import Header from "./components/Header";

// Import Pages
import PageContact from './pages/PageContact';
import accessibility from './actions/accessibility';
import PageFrontPage from './pages/PageFrontPage';
import PageNews from './pages/PageNews';
import Page404 from './pages/Page404';
import FeaturedCollectionItems from './pages/FeaturedCollectionItems';
import CollectionItems from './pages/CollectionItems';
import HistoryCardsBlock from './pages/HistoryCardsBlock';
import toggleImageRights from './actions/toggleImageRights';
import renderMuseumSlider from "./actions/renderMuseumSlider";
import Aos from "./components/aos";
import renderFeaturedSlider from "./actions/renderFeaturedSlider";
import renderHomepageSlider from "./actions/renderHomepageSlider";

import initializeBlockGifs from "./actions/initializeBlockGifs";

// call functions
accessibility();
PageContact($);
PageFrontPage($);
PageNews($);
Header($);
Page404($);
FeaturedCollectionItems($);
CollectionItems($);
HistoryCardsBlock($);
toggleImageRights();
renderMuseumSlider($);
renderFeaturedSlider($);
Aos();
renderHomepageSlider($);
initializeBlockGifs();
